import React from 'react';
import PropTypes from 'prop-types';

const CommentPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M4 6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10.37l8.812 5.874a.5.5 0 0 0 .766-.52L22.814 24H28a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H4z"
    />
  );
};

CommentPath.propTypes = {
  fill: PropTypes.string,
};

export default CommentPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/interaction/comment.jsx